import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=29ffcf52&"
import script from "./LocalePicker.vue?vue&type=script&lang=js&"
export * from "./LocalePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ffcf52')) {
      api.createRecord('29ffcf52', component.options)
    } else {
      api.reload('29ffcf52', component.options)
    }
    module.hot.accept("./LocalePicker.vue?vue&type=template&id=29ffcf52&", function () {
      api.rerender('29ffcf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/LocalePicker.vue"
export default component.exports